import { render, staticRenderFns } from "./diagnosticoOperacoes.vue?vue&type=template&id=588a9f13&lang=pug"
import script from "./diagnosticoOperacoes.vue?vue&type=script&lang=js"
export * from "./diagnosticoOperacoes.vue?vue&type=script&lang=js"
import style0 from "./diagnosticoOperacoes.vue?vue&type=style&index=0&id=588a9f13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports